import { FC } from "react";
import { Typography } from "@mui/material";
import { FooterWrapper } from "./Footer.style";
import { redirectToNewTab } from "utils/redirectToUrl";
import { POLICY_URL } from "constants/constants";
import { useStoreContext } from "context/storeContext";

type IFooterProps = {};

export const Footer: FC<IFooterProps> = () => {
  const {
    states: { darkMode },
  } = useStoreContext();

  return (
    <FooterWrapper className="footer-container" darkMode={darkMode}>
      <div className="footer">
        <div className="footer-inner">
          <Typography
            className="link"
            onClick={() => redirectToNewTab(POLICY_URL)}
          >
            Privacy Policy
          </Typography>
          <Typography className="copy-right">
            © 2024 Algorithmica. All rights reserved.
          </Typography>
        </div>
      </div>
    </FooterWrapper>
  );
};
